<template>
    <b-form-radio
        :button-variant="(outline ? 'outline-' : '') + color"
        :checked="checked"
        :class="['form-input-radio', {'placeholder-label': label === false }]"
        :disabled="disabled"
        :inline="inline"
        :name="name"
        :required="required"
        :size="size"
        :state="state"
        :value="value"
        @click.native="$emit('click', $event)"
        @input="$emit('input', $event)"
    >
        <slot />
    </b-form-radio>
</template>

<script>
import { BFormRadio } from 'bootstrap-vue'

export default {
    components: { BFormRadio },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
    },
    model: {
        prop: 'checked',
        event: 'input'
    },
    props: {
        checked: { type: [Boolean, Number, String], default: null },
        disabled: { type: Boolean },
        inline: { type: Boolean, default: false },
        label: { type: [String, Boolean], default: '' },
        large: { type: Boolean, default: false },
        name: { type: String },
        outline: { type: Boolean },
        color: { type: String },
        required: { type: Boolean, default: false },
        small: { type: Boolean, default: false },
        state: { type: Boolean, default: null },
        value: { type: [Boolean, Number, String], default: '' },
    }
}
</script>